import {Time} from 'yougile-util'

/**
 * GTD (Get Things Done) functionality of tasks
 */

export type GTDStage = 'new' | 'current' | 'backlog' | 'done'

interface GTDState {
  stage: GTDStage
}

export interface GTD {
  state?: GTDState
  lastReason?: string
  history?: {
    [time: number]: GTDState
  }
  reasons?: {
    [time: number]: string
  }
}

const safeGetLocationPathname = () => {
  if (typeof window === 'undefined') {
    return ''
  }
  return window.location?.pathname || 'unknown'
}

export const addGTDStage = (
  gtd: GTD | undefined,
  stage: GTDStage,
  reason = 'unknown'
): GTD => {
  const reasonWithLocation = `${reason} (location: ${safeGetLocationPathname()})`
  if (!gtd) {
    return {
      state: {stage},
      history: {[Time.now()]: {stage}},
      reasons: {[Time.now()]: reasonWithLocation + ' (gtd-created)'},
      lastReason: reasonWithLocation + ' (gtd-created)'
    }
  } else {
    if (gtd.state && gtd.state.stage === stage) {
      if (gtd.lastReason === reasonWithLocation) {
        return gtd
      }
      return {
        ...gtd,
        reasons: {...(gtd.reasons || {}), [Time.now()]: reasonWithLocation},
        lastReason: reasonWithLocation
      }
    } else {
      return {
        state: {stage},
        history: {...(gtd.history || {}), [Time.now()]: {stage}},
        reasons: {...(gtd.reasons || {}), [Time.now()]: reasonWithLocation},
        lastReason: reasonWithLocation
      }
    }
  }
}

export const getGTDStage = (gtd: GTD | undefined): GTDStage | undefined => {
  if (!gtd || !gtd.state) {
    return undefined
  }
  return gtd.state.stage
}

export const getGTDLastChangeTime = (
  gtd: GTD | undefined,
  fallbackTime?: number
): number | undefined => {
  if (!gtd || !gtd.state || !gtd.history) {
    return fallbackTime
  }
  const times = Object.keys(gtd.history)
  return times.length > 0 ? Number(times[times.length - 1]) : fallbackTime
}
